<template >
  <header class="header" id="header" ref="headerEl">
    <div class="container">
      <router-link to="/" class="header-logo">
        <img src="@/assets/img/logo.svg" alt="NICE D&amp;B" />
      </router-link>
      <nav class="navbar">
        <ul>
          <li :class="{ active: isServiceActive }">
            <a @click="toggleMenu('service')">서비스 소개</a>
            <ul class="navbar-sub-list" data-menu="service">
              <li>
                <router-link to="/intro-duns" @click.prevent="closeAll">온라인 기업인증</router-link>
              </li>
              <li>
                <router-link to="/intro-bir" @click.prevent="closeAll">자사 및 해외신용조사 보고서</router-link>
              </li>
              <li>
                <router-link to="/intro-compliance" @click.prevent="closeAll">컴플라이언스 서비스</router-link>
              </li>
              <li>
                <router-link to="/intro-api" @click.prevent="closeAll">API 서비스</router-link>
              </li>
              <li>
                <router-link to="/intro-hoovers" @click.prevent="closeAll">해외기업 정보검색</router-link>
              </li>
              <li>
                <router-link to="/intro-data" @click.prevent="closeAll">해외기업 DATA</router-link>
              </li>
              <li>
                <router-link to="/intro-ra" @click.prevent="closeAll">D&amp;B Risk Analytics</router-link>
              </li>
              <li>
                <router-link to="/intro-fa" @click.prevent="closeAll">D&amp;B Finance Analytics</router-link>
              </li>
              <li>
                <router-link to="/intro-etc" @click.prevent="closeAll">정부지원사업</router-link>
              </li>
            </ul>
          </li>
          <li>
            <router-link to="/apply-main" @click.prevent="closeAll">서비스 신청</router-link>
          </li>
          <li :class="{ active: isCsActive }">
            <a @click="toggleMenu('cs')">고객센터</a>
            <ul class="navbar-sub-list" data-menu="customer">
              <li>
                <!-- <router-link to="/cs-notice" @click.prevent="closeAll">공지사항</router-link> -->
              </li>
              <li>
                <router-link to="/cs-faq" @click.prevent="closeAll">FAQ</router-link>
              </li>
              <li>
                <router-link to="/cs-qna" @click.prevent="closeAll">Q&amp;A</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <div class="header-right">
        <div class="header-right-link">
          <router-link
            :to="isLogin ? '/mypage-usage' : '/join'"
            class="header-join"
          >{{isLogin ? '마이페이지' : '회원가입'}}</router-link>
          <router-link v-if="!isLogin" to="/login" class="btn btn-outline-primary header-login">로그인</router-link>
          <a v-if="isLogin" class="btn btn-outline-primary header-login" @click="logout">로그아웃</a>
        </div>
        <!-- 모바일용 버튼 -->
        <button type="button" class="header-menu" @click="toggleSidebar">
          <img src="@/assets/img/ico/i-menu.svg" alt="메뉴 열기" />
        </button>
      </div>
    </div>
  </header>
  <div class="mobile-sidebar" :class="{show: isSidebarShow}" id="sidebar">
    <div class="mobile-sidebar-header">
      <div class="sidebar-link">
        <router-link
          v-if="!isLogin"
          to="/login"
          class="btn btn-outline-primary header-login"
          @click.prevent="closeSidebar"
        >로그인</router-link>
        <a
          v-if="isLogin"
          class="btn btn-outline-primary header-login"
          @click.prevent="closeSidebar"
          @click="logout"
        >로그아웃</a>

        <router-link
          :to="isLogin ? '/mypage-usage' : '/join'"
          class="header-join"
          @click.prevent="closeSidebar"
        >{{isLogin ? '마이페이지' : '회원가입'}}</router-link>
      </div>
      <button type="button" class="btn-sidebar-colse" @click="closeSidebar">
        <img src="@/assets/img/ico/i-colse.svg" alt="사이드바 닫기" />
      </button>
    </div>
    <div class="mobile-sidebar-body">
      <ul>
        <li :class="{active: isSidebarServiceActive}">
          <a @click="toggleSidebarMenu('service')">
            서비스 소개
            <span class="arrow">
              <img src="@/assets/img/ico/i-arrow-down.svg" alt="열기" />
            </span>
          </a>
          <ul class="sidebar-sub-list">
            <li>
              <router-link to="/intro-duns" @click.prevent="closeSidebar">온라인 기업인증</router-link>
            </li>
            <li>
              <router-link to="/intro-bir" @click.prevent="closeSidebar">자사 및 해외신용조사 보고서</router-link>
            </li>
            <li>
              <router-link to="/intro-compliance" @click.prevent="closeSidebar">컴플라이언스 서비스</router-link>
            </li>
            <li>
              <router-link to="/intro-api" @click.prevent="closeSidebar">API 서비스</router-link>
            </li>
            <li>
              <router-link to="/intro-hoovers" @click.prevent="closeSidebar">해외기업 정보검색</router-link>
            </li>
            <li>
              <router-link to="/intro-data" @click.prevent="closeSidebar">해외기업 DATA</router-link>
            </li>
            <li>
              <router-link to="/intro-ra" @click.prevent="closeSidebar">D&amp;B Risk Analytics</router-link>
            </li>
            <li>
              <router-link to="/intro-fa" @click.prevent="closeSidebar">D&amp;B Finance Analytics</router-link>
            </li>
            <li>
              <router-link to="/intro-etc" @click.prevent="closeSidebar">정부지원사업</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/apply-main" @click.prevent="closeSidebar">서비스 신청</router-link>
        </li>
        <li :class="{active: isSidebarCsActive}">
          <a @click="toggleSidebarMenu('cs')">
            고객센터
            <span class="arrow">
              <img src="@/assets/img/ico/i-arrow-down.svg" alt="열기" />
            </span>
          </a>
          <ul class="sidebar-sub-list">
            <li>
              <!-- <router-link to="/cs-notice" @click.prevent="closeSidebar">공지사항</router-link> -->
            </li>
            <li>
              <router-link to="/cs-faq" @click.prevent="closeSidebar">FAQ</router-link>
            </li>
            <li>
              <router-link to="/cs-qna" @click.prevent="closeSidebar">Q&amp;A</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  emits: ["open-sidebar"],
  data() {
    return {
      isServiceActive: false,
      isCsActive: false,
      isSidebarShow: false,
      isSidebarServiceActive: false,
      isSidebarCsActive: false,
      _boundHandleClickOutside: null,
    };
  },
  computed: {
    ...mapGetters("userStore", ["isLogin"]),
  },
  mounted() {
    this._boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this._boundHandleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this._boundHandleClickOutside);
  },
  methods: {
    async logout() {
      await this.$store.dispatch("userStore/LOGOUT");
      this.$router.push("/");
    },
    toggleMenu(type) {
      if (type === "service") {
        this.isServiceActive = !this.isServiceActive;
        this.isCsActive = false;
      } else if (type === "cs") {
        this.isCsActive = !this.isCsActive;
        this.isServiceActive = false;
      }
    },
    toggleSidebar() {
      this.isSidebarShow = !this.isSidebarShow;
    },
    toggleSidebarMenu(type) {
      if (type === "service") {
        this.isSidebarServiceActive = !this.isSidebarServiceActive;
        this.isSidebarCsActive = false;
      } else if (type === "cs") {
        this.isSidebarCsActive = !this.isSidebarCsActive;
        this.isSidebarServiceActive = false;
      }
    },
    closeAll() {
      this.isServiceActive = false;
      this.isCsActive = false;
    },
    closeSidebar() {
      this.isSidebarShow = false;
      this.isSidebarServiceActive = false;
      this.isSidebarCsActive = false;
    },
    //메뉴박스 바깥 클릭시 active 해제
    handleClickOutside(event) {
      const root = this.$refs.headerEl;
      if (!root) {
        return;
      }

      const serviceLi = root
        .querySelector('li > .navbar-sub-list[data-menu="service"]')
        ?.closest("li");
      const customerLi = root
        .querySelector('li > .navbar-sub-list[data-menu="customer"]')
        ?.closest("li");

      const clickedInsideService =
        serviceLi && serviceLi.contains(event.target);
      const clickedInsideCustomer =
        customerLi && customerLi.contains(event.target);

      const clickedInsideCurrentMenu =
        (this.isServiceActive && clickedInsideService) ||
        (this.isCsActive && clickedInsideCustomer);

      if (!clickedInsideCurrentMenu) {
        this.closeAll();
      }
    },
  },
};
</script>
<style scoped>
a {
  cursor: pointer;
}
</style>